import type { PrimeVuePTOptions } from 'primevue/config'
import { nextTick } from 'vue'
import { subjectScene } from './workspaceScenes'

function visibilityControl(label: string) {
  return {
    role: 'button',
    tabindex: 0,
    'aria-hidden': false,
    'aria-label': label,
    onKeydown(event: KeyboardEvent) {
      if (event.key !== 'Enter' && event.key !== ' ') return
      event.preventDefault()
      const icon = event.currentTarget as Element
      const field = icon.parentElement
      icon.dispatchEvent(new MouseEvent('click', { bubbles: true }))
      nextTick(() =>
        field?.querySelector<HTMLElement>('[role="button"]')?.focus()
      )
    },
  }
}

export default {
  password: {
    unmaskIcon: visibilityControl('Show characters'),
    maskIcon: visibilityControl('Hide characters'),
  },
  dialog: {
    root: ({ props }) => ({ 'data-scene': subjectScene(props.header ?? '') }),
  },
  drawer: {
    root: ({ props }) => ({ 'data-scene': subjectScene(props.header ?? '') }),
  },
} satisfies PrimeVuePTOptions
